import React from 'react';
import { motion } from 'framer-motion';
import { Map, Handshake, FileSignature, Users } from 'lucide-react';
const pillars = [{
  icon: <Map className="w-5 h-5" data-id="element-488" />,
  title: 'Discovery & Routing',
  description: 'Find venues, artists, and markets that actually fit.'
}, {
  icon: <Handshake className="w-5 h-5" data-id="element-489" />,
  title: 'Deals & Negotiation',
  description: 'Track every conversation, hold, offer, and counter in one place.'
}, {
  icon: <FileSignature className="w-5 h-5" data-id="element-490" />,
  title: 'Contracts & Payments',
  description: 'Generate docs, collect signatures, request deposits, and monitor settlement.'
}, {
  icon: <Users className="w-5 h-5" data-id="element-491" />,
  title: 'Lineup & Tour Ops',
  description: 'Make sure the right people can actually play the show — then carry the gig through day-of logistics.'
}];
export function ProductPillars() {
  return <section className="py-24 bg-surface/10 border-y border-border relative overflow-hidden" data-id="element-492">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-493">
        <div className="mb-16" data-id="element-494">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold" data-id="element-495">
            Built for the full booking lifecycle
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-496">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-surface border border-border rounded-xl p-8 relative overflow-hidden flex flex-col md:flex-row gap-6 items-start hover:border-border/80 transition-colors" data-id="element-497">
              {/* Hover Shimmer */}
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/5 to-transparent group-hover:animate-[shimmer_1.5s_infinite] pointer-events-none" data-id="element-498"></div>

              {/* Animated Left Accent Bar */}
              <motion.div initial={{
            height: 0
          }} whileInView={{
            height: '100%'
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1 + 0.3,
            duration: 0.5,
            ease: 'easeOut'
          }} className="absolute left-0 top-0 w-1 bg-primary/50 group-hover:bg-primary transition-colors" data-id="element-499"></motion.div>

              <div className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center text-primary shrink-0 group-hover:rotate-12 group-hover:shadow-[0_0_15px_rgba(245,158,11,0.3)] transition-all duration-300" data-id="element-500">
                {pillar.icon}
              </div>

              <div className="relative z-10" data-id="element-501">
                <h3 className="text-xl font-semibold mb-2 group-hover:text-white transition-colors" data-id="element-502">
                  {pillar.title}
                </h3>
                <p className="text-textMuted leading-relaxed" data-id="element-503">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}